module.exports = __webpack_public_path__ + "img/popup_option4.689d2a0.png";